import receiveRupee from "./receive-rupee.png";
import sendRupee from "./send-rupee.png";

export const ICONS = {
  RECEIVE_RUPEE: receiveRupee,
  SEND_RUPEE: sendRupee,
};
